import classNames from 'classnames';
import React, { ReactNode, useId } from 'react';

interface Props {
  title?: ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  children: ReactNode;
  disabled?: boolean;
}

export function BaseBox(props: Props) {
  const id = useId();
  const { title, required = false, error, className, children, disabled = false } = props;

  return (
    <div className={className}>
      {title && (
        <label
          htmlFor={id}
          className="typography-h6 text-purple_700 font-medium mb-1 md:mb-2 block"
        >
          {title} {required && <span className="text-error">*</span>}
        </label>
      )}
      <div
        className={classNames(
          'text-base border border-gray_300 bg-white font-medium text-gray_700 py-3.5 px-4 rounded-md',
          {
            '!bg-gray_50': disabled,
            '!border-error': error,
          }
        )}
      >
        {children}
      </div>
      {error && <span className="text-error text-[10px] md:text-sm">{error}</span>}
    </div>
  );
}
